import { getAppProps } from '../utils';
import { getTargetProductId } from '../utils/item';
import { createAddOnRecord } from '../addOnsUtil';

export const DISCOUNT_OFFER_OPTIONS = '__options__';

export function getDiscountOfferInfo() {
  return new URL(window.location.href).searchParams.get('custom_offer');
}

export function getDiscountOfferInfoValues() {
  const info = getDiscountOfferInfo();
  if (!info) {
    return null;
  }
  const splitted = info.split('_');
  if (splitted.length < 2) {
    return null;
  }
  return {
    productId: parseInt(splitted[0]),
    optionId: splitted[1]
  };
}

export function getItemDiscountForOffer(item) {
  const { discount_offer } = getAppProps();

  const info = getDiscountOfferInfoValues();
  if (!info) {
    return 0;
  }

  const product = discount_offer[info.productId];
  if (product) {
    const option = product[info.optionId];
    if (option) {
      const record = readOptionRecord(option[DISCOUNT_OFFER_OPTIONS]);
      const discount = record.discount;
      if (discount > 0) {
        const { variant_id } = item;

        const addOns = option;
        for (const key in addOns) {
          if (key !== DISCOUNT_OFFER_OPTIONS) {
            const parsed = createAddOnRecord(addOns, key);
            if (parsed.ids.includes(variant_id)) {
              return discount;
            }
          }
        }
      }
    }
  }
  return 0;
}

export function getDiscountOfferSettings(targetProductId) {
  const { discount_offer } = getAppProps();
  const id = targetProductId || getTargetProductId();
  const settings = discount_offer[id];
  if (settings) {
    return settings;
  }
  return false;
}

export function isValidOptions(offerSettings) {
  const options = getOptions(offerSettings);

  for (const optionId in options) {
    const option = options[optionId];
    const addons = getAddons(option);
    if (addons.length !== 0) {
      return true;
    }
  }

  return false;
}

export function getOptions(offerSettings) {
  const settings = offerSettings || getDiscountOfferSettings();
  const records = {};
  const addonsIds = Object.keys(settings)
    // exclude special property options
    .filter(value => value !== DISCOUNT_OFFER_OPTIONS);

  addonsIds.forEach(offerId => {
    records[offerId] = {};
    Object.keys(settings[offerId]).forEach(productHandle => {
      if (productHandle === DISCOUNT_OFFER_OPTIONS) {
        records[offerId][productHandle] = readOptionRecord(
          settings[offerId][productHandle]
        );
      } else {
        records[offerId][productHandle] = createAddOnRecord(
          settings[offerId],
          productHandle
        );
      }
    });
  });

  return records;
}

export function getAddons(option) {
  const records = {};
  const addonsIds = Object.keys(option)
    // exclude special property options
    .filter(value => value !== DISCOUNT_OFFER_OPTIONS);

  addonsIds.forEach(addOnId => {
    records[addOnId] = option[addOnId];
  });

  return records;
}

export function readOptionRecord(record) {
  const info = {
    discount: 0
  };
  const splitted = record.split('|');
  const len = splitted.length;

  if (len > 0) {
    info.text = splitted[0];
  }

  if (len > 1) {
    info.discount = parseInt(splitted[1]);
  }

  return info;
}
